import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async sendEmail({ commit }, data) {
      try {
        return await api.post('/send-email', data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
